import React from "react";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getPathWithParam,
} from "../../utils";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faSpinner } from "@fortawesome/pro-light-svg-icons";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const ProgressBarLayout = ({ index, length, item, feeId, selectedMenu }) => {
  const history = useHistory();
  const location = useLocation();
  const onClickSteps = (path) => {
    console.log("andy", history, location);
    history.push(
      getAdvancedPathWithParam({
        path: location.pathname.includes("edit")
          ? `${path}/${FLOW_TYPES.EDIT}/${feeId}`
          : location.pathname.includes("save")
          ? `${path}/${FLOW_TYPES.SAVE}/${feeId}`
          : `${path}/${feeId}`,
      })
    );
  };
  return (
    <>
      <li
        onClick={() => (item.status != 1 ? onClickSteps(item.path) : null)}
        key={`${item.path}/${feeId}`}
        className={`${selectedMenu} mt-2 ${
          item.status != 1 && `cursor-pointer`
        }`}
      >
        <div className="d-flex">
          <div className="mt-1">
            {item.status == 1 ? (
              <div className="inProgressStatus">
                <FontAwesomeIcon
                  style={{ color: "white" }}
                  size="lg"
                  icon={faCircle}
                />
              </div>
            ) : item.status == 2 ? (
              <div className="isPending">
                <FontAwesomeIcon
                  style={{ color: "white" }}
                  size="lg"
                  icon={faSpinner}
                />
              </div>
            ) : (
              <div className="isCompleted">
                <FontAwesomeIcon
                  style={{ color: "white" }}
                  size="lg"
                  icon={faCheck}
                />
              </div>
            )}
          </div>
          <div className="ml-3">
            <div className="grey-text">Step {item.step}</div>
            {item.label}
          </div>
        </div>
      </li>
      {index == length - 1 ? null : item.status == 1 ? (
        <div className="isPendingLine"></div>
      ) : item.status == 2 ? (
        <div className="d-flex">
          <div className="inProgressLine"></div>
          {/* <span className="inProgressText">In Processing</span> */}
        </div>
      ) : item.status == 3 ? (
        <div className="d-flex">
          <div className="completedLine"></div>
          {/* <span className="completedText">Completed</span> */}
        </div>
      ) : null}
    </>
  );
};

export default ProgressBarLayout;
